import { getObjectLength, caculateGiftCardAmounts, getPlainUuid } from '../../utils/util';

const getVal = require('lodash/get');

export const entityOperations = (entityOperationProps) => {
  const { props, entityOperationType } = entityOperationProps;
  const {
    dataObj, entityData, entityId, formContainer, s3FileInfo, renderingEl, idsToClear, entityToEdit,
    index, entity, keysToUpdate = {},
  } = props.dataObject;
  const {
    setFormSubmissionPayload, setEntityData, dispatchIdsState, setEntityToEdit,
  } = props.functionObject;

  const entityOps = {
    addEntity: () => {
      // write add entity functionality in json.
      // write field operations to create legalEntityAddress field
      // write operations to extract file names from fileData

      if (Object.prototype.hasOwnProperty.call(dataObj, 'compositeKey') && dataObj.compositeKey === '') {
        const compositeKey = getPlainUuid();
        dataObj.compositeKey = compositeKey;
      }

      const prevEntities = entityData[entityId] && entityData[entityId].length > 0
        ? [...entityData[entityId]]
        : [];

      let newEntity = { ...dataObj };
      let canAddEntity = true;
      if (formContainer.operations && formContainer.operations.addEntity) {
        formContainer.operations.addEntity.forEach((operation) => {
          if (operation.entityToOperate === entityId) {
            switch (operation.operationType) {
              case 'removeFields':
                operation.fieldsToRemove.forEach((field) => {
                  if (Object.prototype.hasOwnProperty.call(newEntity, field)) {
                    delete newEntity[field];
                  }
                });
                break;
              case 'combineFields':
                {
                  let newField = '';
                  operation.fieldsToCombine.forEach((field, ind) => {
                    let val = getVal(operation?.source
                      ? getVal(props.dataObject, operation.source)
                      : newEntity, field);
                    val = val && val !== '' ? val.trim() : null;
                    if (val) {
                      newField += (ind > 0) && (newField !== '') ? `${operation.combineChar}${val}` : `${val}`;
                    }
                  });
                  if (newField !== '') {
                    newEntity = { ...newEntity, [operation.addAs]: newField.trim() };
                  }
                }
                break;
              case 'addFilesToEntity':
                {
                  const files = [...s3FileInfo];
                  // const intitialLength = files.length;
                  if (files.length > 0) {
                    operation.filesToAdd.forEach((fileId) => {
                      // check if this fileId is there inside files
                      const filesForCurId = [];
                      files.forEach((fileObj) => {
                        if (fileObj.fileFrom === fileId) {
                          // add this file under this entity and take out from s3FileInfo
                          filesForCurId.push(fileObj);
                        }
                      });
                      if (filesForCurId.length > 0) {
                        newEntity = { ...newEntity, [fileId]: filesForCurId };
                      }
                    });
                  }
                }
                break;
              case 'japanGiftCards':
                { /* eslint-disable max-len -- need */
                  // return newEntity
                  // pass setFormSubmissionPayload, formSubmissionPayload, memberInfo
                  const sellingPriceNum = Number(getVal(newEntity, 'JapanGCOrderInfo_denomination_1533213').split('|')[1]);
                  const faceValueNum = Number(getVal(newEntity, 'JapanGCOrderInfo_denomination_1533213').split('|')[0]);
                  const subTotalNum = sellingPriceNum * Number(getVal(newEntity, 'JapanGCOrderInfo_noofcards_321345sa13'));
                  // convert all the values to JPY
                  const sellingPrice = Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(sellingPriceNum);
                  const sellingPriceWithoutSymbol = Intl.NumberFormat('ja-JP').format(sellingPriceNum);
                  const faceValue = Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(faceValueNum);
                  const faceValueWithoutSymbol = Intl.NumberFormat('ja-JP').format(faceValueNum);
                  const subTotal = Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(subTotalNum);
                  const subTotalWithoutSymbol = Intl.NumberFormat('ja-JP').format(subTotalNum);
                  // const numTotal = parseInt(subTotal.replace(/[^0-9.-]+/g, ""),10);
                  newEntity = {
                    ...newEntity,
                    sellingPrice,
                    sellingPriceWithoutSymbol,
                    sellingPriceNum: String(sellingPriceNum),
                    faceValue,
                    faceValueWithoutSymbol,
                    faceValueNum: String(faceValueNum),
                    subTotal,
                    subTotalWithoutSymbol,
                    subTotalNum: String(subTotalNum),
                  };
                  const { totalAmount, shippingFee } = caculateGiftCardAmounts([...prevEntities, newEntity]);
                  // if total amount exceeds 1 million yen, show error
                  if (totalAmount > 1000000) {
                    canAddEntity = false;
                    setFormSubmissionPayload((prev) => ({
                      ...prev,
                      elemId: null,
                      totalGiftCardAmountExceeds: true,
                    }));
                  } else {
                    setFormSubmissionPayload((prev) => {
                      delete prev.errorRemainingAmount;
                      return {
                        ...prev,
                        elemId: null,
                        totalGiftCardAmount: totalAmount,
                        totalGiftCardAmountWithoutSymbol: Intl.NumberFormat('ja-JP').format(totalAmount),
                        totalGiftCardAmountWithoutShippingFees: String(totalAmount - shippingFee),
                        totalGiftCardAmountWithoutShippingFeesWithoutSymbol: Intl.NumberFormat('ja-JP').format(totalAmount - shippingFee),
                        shippingFee,
                        shippingFeeWithoutSymbol: Intl.NumberFormat('ja-JP').format(shippingFee),
                        totalGiftCardAmountExceeds: false,
                        totalGiftCardAmountExceedsAvailableCredit: false,
                      };
                    });
                  }
                  /* eslint-enable max-len -- need */
                }
                break;
              default: newEntity = { ...newEntity };
            }
          }
        });
      }

      if (canAddEntity) {
        prevEntities.push(newEntity);
        setEntityData((curState) => ({ ...curState, [entityId]: prevEntities }));

        // If any input needs to cleanup
        if (renderingEl.fieldIdsToClear && renderingEl.fieldIdsToClear.length > 0) {
          const clearIds = {};
          renderingEl.fieldIdsToClear.forEach((id, i) => {
            clearIds[id] = i + 1;
          });
          dispatchIdsState({ toggleState: !idsToClear.toggleState, ids: clearIds });
        }
        // If entityToEdit has data, cleanup that too
        if (getObjectLength(entityToEdit) > 0) {
          setEntityToEdit({});
        }
      }
    },
    removeEntity: () => {
      entityData[entity].splice(index, 1);
      if (entityData && entityData[entity]
        && entityData[entity].length === 0
        && Object.keys(keysToUpdate).length > 0) {
        setFormSubmissionPayload((prev) => ({
          ...prev,
          ...keysToUpdate,
          elemId: null,
        }));
      }
      if (formContainer?.operations?.removeEntity) {
        formContainer.operations.removeEntity.forEach((operation) => {
          if (operation.entityToOperate === entity) {
            switch (operation.operationType) {
              case 'japanGiftCards':
                {
                  const { totalAmount, shippingFee } = caculateGiftCardAmounts(entityData[entity]);
                  setFormSubmissionPayload((prev) => {
                    delete prev.errorRemainingAmount;
                    return {
                      ...prev,
                      elemId: null,
                      totalGiftCardAmount: totalAmount,
                      totalGiftCardAmountWithoutSymbol: Intl.NumberFormat('ja-JP').format(totalAmount),
                      totalGiftCardAmountWithoutShippingFees: String(totalAmount - shippingFee),
                      totalGiftCardAmountWithoutShippingFeesWithoutSymbol: Intl.NumberFormat('ja-JP').format(totalAmount - shippingFee),
                      shippingFee,
                      shippingFeeWithoutSymbol: Intl.NumberFormat('ja-JP').format(shippingFee),
                      totalGiftCardAmountExceeds: false,
                      totalGiftCardAmountExceedsAvailableCredit: false,
                    };
                  });
                }
                break;
              default: break;
            }
          }
        });
      }
      setEntityData({ ...entityData });
    },
    editEntity: () => {
      dispatchIdsState({ ids: {} });
      setEntityToEdit(entityData[entity][index]);
      entityOps.removeEntity();
    },
  };
  entityOps[entityOperationType]();
};
